import { render, staticRenderFns } from "./user-management-panel.vue?vue&type=template&id=b5fba7f4"
import script from "./user-management-panel.vue?vue&type=script&lang=js"
export * from "./user-management-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports